import React from 'react';
import * as Styled from './styled';

export const Loader = () => (
  <Styled.LoaderWrapper />
);
